<template>
    <aside class="app-sidebar d-print-none" id="app-sidebar" v-if="filterSet">
        <header class="sidebar-header">
            <h2 class="m-0 h5">Filters</h2>

            <b-button @click="clearAll" size="sm" variant="secondary">
                Clear All
            </b-button>
        </header>

        <div class="sidebar-form">
            <div
                class="form-group"
                role="group"
                :id="fieldId(key)"
                v-bind:key="index"
                v-for="(value, key, index) in filterSet"
            >
                <label class="form-group-header">
                    <strong>{{ getLabel(key) }}</strong>
                    <b-button
                        @click="toggleGroup(key)"
                        size="sm"
                        variant="outline-secondary"
                    >
                        Toggle
                    </b-button>
                </label>
                <b-form-checkbox-group
                    stacked
                    v-if="value"
                    v-model="selected[key]"
                    :options="value"
                >
                </b-form-checkbox-group>
            </div>
        </div>
    </aside>
</template>

<script>
import { get } from "lodash-es";
import { FIELDS } from "@/shared/constants.js";

export default {
    name: "AppSidebar",
    props: {
        filterSet: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            selected: {
                DataSources: [],
                Services: [],
                ZipCodes: []
            }
        };
    },
    watch: {
        selected: {
            deep: true,
            handler(newValue) {
                this.$emit("filterChange", newValue);
            }
        }
    },
    methods: {
        fieldId(key) {
            return `field-${key}`;
        },
        getLabel(key) {
            const short = get(FIELDS[key], "short");
            const long = get(FIELDS[key], "long");

            return long ? long : short ? short : key;
        },
        toggleGroup(dataset) {
            const filterSet = this.filterSet[dataset];
            if (this.selected[dataset].length < filterSet.length) {
                this.selected[dataset] = filterSet;
            } else this.selected[dataset] = [];
        },
        clearAll() {
            this.selected.DataSources = [];
            this.selected.Services = [];
            this.selected.ZipCodes = [];
        }
    }
};
</script>

<style lang="scss">
@mixin column-layout() {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.app-sidebar {
    border-top: 1px solid $border-color;

    @include media-breakpoint-up(lg) {
        @include column-layout();
        width: 240px;
        background: #fff;
        border: 0;
        border-left: 1px solid $border-color;

        .btn {
            padding: 0 $spacer-2;
        }
    }

    .sidebar-header {
        display: flex;
        padding: $spacer;
        border-bottom: 1px solid $border-color;

        h2 {
            flex: 1;
        }
    }

    .sidebar-form {
        padding: $spacer-2;

        @include media-breakpoint-up(lg) {
            @include column-layout();
            flex: 1;
        }
    }

    .form-group {
        padding: $spacer-2;
        margin: 0;

        @include media-breakpoint-up(sm) {
            font-size: 0.875rem;

            .custom-control-label::before,
            .custom-control-label::after {
                top: 0.125rem;
            }
        }

        @include media-breakpoint-up(lg) {
            @include column-layout();
            flex: 1;
        }

        .form-group-header {
            display: flex;

            strong {
                flex: 1;
            }
        }

        > div[role="group"] {
            outline: none;
            flex: 1;
            overflow-y: auto;
        }
    }
}
</style>
